/** Chave de idempotência de um rascunho (uma por pré-visualização): a mesma chave nunca envia duas vezes. */
export function newEmailIdempotencyKey(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `draft-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

/** 409 = o rascunho mudou desde a pré-visualização (ou o mesmo envio já está em andamento). */
export function isEmailDraftConflict(error: unknown): boolean {
  return (error as { response?: { status?: number } })?.response?.status === 409;
}
